import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  SummaryTitle,
  Table,
  TableCell,
  SummaryContainer,
  CellLabel,
  CellValueLink,
  TableDivider,
} from '../css';
import { AddDocumentsButton } from './css';
// import { endpoints } from '../../../utils/constants';
import AddDocumentsForm from './AddDocumentsForm';
import downloadDocument from './api';

const PODDocuments = ({ data, handleSubmitFiles, accountNumbers }) => {
  const [isAddingDocuments, setIsAddingDocuments] = useState(false);

  const stopAddingDocuments = (e) => {
    e.preventDefault();
    setIsAddingDocuments(false);
  };

  const startAddingDocuments = (e) => {
    e.preventDefault();
    setIsAddingDocuments(true);
  };

  const handleDownload = (documentId) => {
    downloadDocument(documentId, accountNumbers, documentId);
  };

  return (
    <SummaryContainer>
      <SummaryTitle>
        {t('PODDocuments')}
        <AddDocumentsButton onClick={startAddingDocuments}>
          {t('AddDocuments')}
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                        // eslint-disable-next-line max-len
              d="M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.1034 4.66667C10.3737 4.66667 10.5928 4.88574 10.5928 5.15598V9.51101H14.9475C15.2177 9.51101 15.4368 9.73009 15.4368 10.0003C15.4368 10.2706 15.2177 10.4896 14.9475 10.4896L10.5928 10.4896V14.844C10.5928 15.1143 10.3737 15.3333 10.1035 15.3333C9.83321 15.3333 9.61414 15.1143 9.61414 14.844V10.4896L5.25944 10.4896C4.98919 10.4896 4.77012 10.2706 4.77012 10.0003C4.77012 9.73009 4.98919 9.51101 5.25943 9.51101H9.61414V5.15598C9.61414 4.88574 9.83321 4.66667 10.1034 4.66667Z"
              fill="#E55916"
            />
          </svg>
        </AddDocumentsButton>
      </SummaryTitle>
      {data.length > 0 && (
      <Table>
        {data.map(({ fileType, documentId }) => (
          <React.Fragment key={documentId}>
            <TableCell>
              <CellLabel>{fileType}</CellLabel>
              {/* <CellValueLink
                            // eslint-disable-next-line max-len
                href={`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadFile}?fileId=${documentId}`}
                target="_blank"
              > */}
              <CellValueLink
                onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documentId);
                }}
              >
                {documentId}
              </CellValueLink>
            </TableCell>
            <TableDivider />
          </React.Fragment>
        ))}
      </Table>
      )}
      {isAddingDocuments
                && <AddDocumentsForm handleSubmitFiles={handleSubmitFiles} stopAddingDocuments={stopAddingDocuments} />}
    </SummaryContainer>
  );
};

PODDocuments.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    fileType: PropTypes.string,
    documentId: PropTypes.string,
  })),
  handleSubmitFiles: PropTypes.func,
  accountNumbers: PropTypes.array,
};

export default PODDocuments;
